import { createContext, useContext } from "react";

export interface MortgageFormContextValue {
	isLoading: boolean;
	isReadOnly: boolean;
}

export const MortgageFormContext = createContext<MortgageFormContextValue | null>(null);

export function useMortgageFormContext(): MortgageFormContextValue {
	const ctx = useContext(MortgageFormContext);
	if (!ctx) {
		throw new Error(
			"useMortgageFormContext must be used inside MortgageFormProvider",
		);
	}
	return ctx;
}
